// src/types/Incident.ts

export interface Incident {
  ticketId: string;
  incidentCrossReference: string;
  ticketCreationDatetime: string;
  ticketClosureDatetime: string;
  incidentStartDatetime: string;
  incidentCloseDatetime: string;
  networkId: string | number | undefined;
  siteId: string | number | undefined;
  linkId: string | number | undefined;
  assetId: string | number | undefined;
  teamId: string | number | undefined;
  personId: string | number | undefined;
  communicationWithCustomer: string;
  userid: any;
  ticketCreation: string;
  ticketClosure: string;
  summary: string;
  incidentStart: string;
  incidentClose: string;
  affectedCustomer: string[];
  email: string;
  affectedNetwork: string[];
  affectedAntenna: string[];
  affectedSite: string[];
  affectedLink: string[];
  asset: string;
  errorType: string;

  closureCode: string;
  createdby: string;
  impact: string;
  urgency: string;
  priority: string;
  responsibleTeam: string;
  responsiblePerson: string;
  customerComplaint: boolean;
  customerInformed: boolean | null;
  status: string;
  journalUpdate: string;
  communication: string;
  sla: string;
  slaStatus: string;
  description: string;
  reactionPoint: string;
  responseTimeToOpen: string;
  responseTimeToClose: string;
  acceptanceTime: string;
  ola: string;
  olaStatus: string;
  acceptanceStatus: string;
  foruserid: number[];
  filePath?: File[] | null;
  uploadPath: string;
  relatedobject: string[];
  solution: string;
  category: string;
}

export const initialIncident: Incident = {
  ticketId: "",
  userid: "",
  ticketCreation: "",
  ticketClosure: "",
  incidentStart: "",
  incidentClose: "",
  affectedCustomer: [],
  affectedNetwork: [],
  affectedAntenna: [],
  affectedSite: [],
  affectedLink: [],
  asset: "",
  summary: "",
  description: "",
  errorType: "",
  createdby: "",

  closureCode: "",
  impact: "",
  urgency: "",
  priority: "",
  responsibleTeam: "",
  responsiblePerson: "",
  customerComplaint: false,
  customerInformed: null,
  email: "",
  status: "",
  journalUpdate: "",
  communication: "",
  sla: "",
  slaStatus: "",
  reactionPoint: "",
  responseTimeToOpen: "",
  responseTimeToClose: "",
  acceptanceTime: "",
  ola: "",
  olaStatus: "",
  ticketCreationDatetime: "",
  ticketClosureDatetime: "",
  incidentStartDatetime: "",
  incidentCloseDatetime: "",
  networkId: undefined,
  siteId: undefined,
  linkId: undefined,
  assetId: undefined,
  teamId: undefined,
  personId: undefined,
  communicationWithCustomer: "",
  acceptanceStatus: "",
  foruserid: [],
  filePath: [],
  uploadPath: "",
  relatedobject: [],
  solution: "",
  incidentCrossReference: "",
  category: "",
};
